import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SearchResultStore {

}

export enum SearchResultStoreKeys {

}
